import {Routes} from '@angular/router';
import {WorkflowComponent} from './workflow.component';
import {modeGuard} from '../../core/guards/mode.guard';

export const WORKFLOW_MY_TIRES_ROUTES = 'my-tires';

export const WORKFLOW_ROUTES: Routes = [
  {
    path: '',
    component: WorkflowComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: WORKFLOW_MY_TIRES_ROUTES,
        loadChildren: () => import('./my-tires/my-tires.routes').then((m) => m.MY_TIRES_ROUTES),
      },
      {
        path: 'my-batches',
        loadChildren: () => import('./my-batches/my-batches.routes').then((m) => m.MY_BATCHES_ROUTES),
      },
      {
        path: 'damage-reports',
        loadChildren: () => import('./damage-reports/damage-reports.routes').then((m) => m.DAMAGE_REPORT_ROUTES),
      },
      {
        path: 'rejected-tires',
        loadChildren: () => import('./rejected-tires/rejected-tires.routes').then((m) => m.REJECTED_TIRES_ROUTES),
      },

      {
        path: 'anomaly-tires',
        loadChildren: () => import('./anomaly-tires/anomaly-tires.routes').then((m) => m.DOUBLE_SN_TIRES_ROUTES),
      },
      {
        path: ':modeUrl/batches',
        canActivate: [modeGuard],
        loadChildren: () => import('./batches-import-export/batches-import-export.routes').then((m) => m.BATCHES_IMPORT_EXPORT_ROUTES)
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
    ],
  },
];
